import { createContext, ReactNode, useContext, useEffect, useState } from "react";

import { useAuth } from "../auth/AuthContext";

interface Brand {
  brandName: string;
  legalEntity: string;
  gmName: string;
  gmEmail: string;
  gmPhone: string;
  callbackPhone: string;
  ownerName: string;
  ownerEmail: string;
  bookingLink: string;
  timezone: string;
}

const FALLBACK_BRAND: Brand = {
  brandName: "",
  legalEntity: "",
  gmName: "",
  gmEmail: "",
  gmPhone: "",
  callbackPhone: "",
  ownerName: "",
  ownerEmail: "",
  bookingLink: "",
  timezone: "",
};

const BrandContext = createContext<Brand>(FALLBACK_BRAND);

export function BrandProvider({ children }: { children: ReactNode }) {
  const { accessToken } = useAuth();
  const [brand, setBrand] = useState<Brand>(FALLBACK_BRAND);

  useEffect(() => {
    if (!accessToken) {
      setBrand(FALLBACK_BRAND);
      return;
    }
    fetch("/api/launcher", {
      headers: { Authorization: `Bearer ${accessToken}` },
      credentials: "include",
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!data) return;
        setBrand({
          brandName: data.brandName ?? "",
          legalEntity: data.legalEntity ?? "",
          gmName: data.gmName ?? "",
          gmEmail: data.gmEmail ?? "",
          gmPhone: data.gmPhone ?? "",
          callbackPhone: data.callbackPhone ?? "",
          ownerName: data.ownerName ?? "",
          ownerEmail: data.ownerEmail ?? "",
          bookingLink: data.bookingLink ?? "",
          timezone: data.timezone ?? "",
        });
      })
      .catch(() => setBrand(FALLBACK_BRAND));
  }, [accessToken]);

  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  return useContext(BrandContext);
}
